import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ContainerComponent } from "./wrappers/container/container.component";
import { FormSectionComponent } from "./wrappers/form-section/form-section.component";
import { FormSectionInnerComponent } from "./wrappers/form-section-inner/form-section-inner.component";
import { FormSectionTitleComponent } from "./wrappers/form-section-title/form-section-title.component";
import { FormControlsModule } from "./form-controls/form-controls.module";
import { ButtonModule } from "./button/button.module";
import { DescriptionItemModule } from "./description-item/description-item.module";
import { BadgeModule } from "./badge/badge.module";
import { BaseModalModule } from "./modal/base-modal.module";
import { FormBlockComponent } from "./wrappers/form-block/form-block.component";

@NgModule({
  declarations: [
    ContainerComponent,
    FormSectionComponent,
    FormSectionInnerComponent,
    FormSectionTitleComponent,
    FormBlockComponent,
  ],
  imports: [
    CommonModule,
    FormControlsModule,
    ButtonModule,
    DescriptionItemModule,
    BadgeModule,
    BaseModalModule,
  ],
  exports: [
    ContainerComponent,
    FormSectionComponent,
    FormSectionInnerComponent,
    FormSectionTitleComponent,
    FormBlockComponent,
    FormControlsModule,
    ButtonModule,
    DescriptionItemModule,
    BadgeModule,
    BaseModalModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UiComponentsModule {}
